import { Injectable } from '@angular/core';
import { GuidTools } from '@models/guid';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { ListResourceStatus } from '@models/imported/SagaStateLib/ListResourceStatus';
import { MyUnitService } from '@services/unit-activity/my-unit/my-unit.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class StatusTimeService {
  private timesObject: any = null;
  private myUnit: UnitActivity = null;
  private myCallcardId: string = null;
  private unitChangeSubscription: Subscription = null;

  constructor(private myUnitService: MyUnitService) {
    this.myUnitService.$unitChanged.subscribe(unitActivity => this.onUnitChanged(unitActivity));
  }

  onUnitChanged(unitActivity: UnitActivity) {
    if (unitActivity) {
      this.init(unitActivity);
    } else {
      if (this.myUnit) {
        this.reset();
      }
      this.unitChangeSubscription?.unsubscribe();
      this.unitChangeSubscription = null;
    }
  }

  private init(unitActivity: UnitActivity) {
    this.myUnit = unitActivity;
    this.unitChangeSubscription = this.myUnit.$changed
      .pipe(filter(() => this.myCallcardId !== this.myUnit.CallCardID))
      .subscribe(() => this.timesInit());
    this.timesInit();
  }

  private timesInit() {
    if (this.myUnit && this.myUnit.CallCardID) {
      this.myCallcardId = this.myUnit.CallCardID;

      this.timesObject = JSON.parse(localStorage.getItem('statusUnitTime'));
      if (!this.timesObject || (!GuidTools.isEmpty(this.myUnit.CallCardID) && this.timesObject.id !== this.myUnit.CallCardID)) {
        this.timesObject = { id: this.myUnit.CallCardID, statuses: {} };
        localStorage.setItem('statusUnitTime', JSON.stringify(this.timesObject));
      }
    }
  }

  setTime(status: ListResourceStatus, date: Date) {
    const time: string = moment(date).format('HH:mm:ss');

    this.timesObject.statuses[status.Value] = time;
    localStorage.setItem('statusUnitTime', JSON.stringify(this.timesObject));
  }

  getTime(status: ListResourceStatus): string {
    return this.timesObject ? this.timesObject.statuses[status.Value] : null;
  }

  reset() {
    localStorage.removeItem('statusUnitTime');
    this.timesInit();
  }
}
